import { RetirableLogoWithText } from 'component-library/components/icons/RetirableLogoWithText';
import { Flex } from 'component-library/components/layout/Flex';
import { LinkWrapper } from 'component-library/components/links/LinkWrapper';
import React, { FC } from 'react';

interface DesktopNavigationRetirableLogoProps {}

export const DesktopNavigationRetirableLogo: FC<DesktopNavigationRetirableLogoProps> = () => (
  <Flex alignItems="center">
    <LinkWrapper to="/">
      <RetirableLogoWithText />
    </LinkWrapper>
  </Flex>
);
